<template>
    <div>
        <v-offline
            online-class="online"
            offline-class="offline"
            @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-md-12 card">
                <div class="card-body row set_row">
                    <div class="col-sm-12 col-xl-12 set_table_center">
                        <table id="hcRecords" class="display table-striped table-bordered select" width="100%">
                            <thead>
                                <tr>
                                    <th><input type="checkbox" id="allCheckbox" @click="inputCheckBox"></th>
                                    <th>Archived Date/Time</th>
                                    <th>Archived by</th>
                                    <th>Photo</th>
                                    <th>Collar ID</th>
                                    <th>Age</th>
                                    <th>Treatment</th>
                                    <th>Deworming</th>
                                    <th>Vaccination</th>
                                </tr>
                            </thead>
                        </table>
                         <button type="button" class="btn" @click="restoreRecord">Restore</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import mixin from '../../../mixins/GlobalMixin';
import {
  Dialog,
  Button,
  Card,
  Row,
  Col,
  Image,
  Form,
  FormItem,
  DatePicker,
  Input,
  Select,
  Option,
  Checkbox,
  Radio,
  RadioGroup,
  Tooltip,
  Alert
} from "element-ui";
import Swal from 'sweetalert2';
import VOffline from 'v-offline';
import healthClinicService from "../../../services/health-clinic.service";
export default {
    components: {
        [Dialog.name]: Dialog,
        [Button.name]: Button,
        [Image.name]: Image,
        [Form.name]: Form,
        [FormItem.name]: FormItem,
        [Input.name]: Input,
        [Select.name]: Select,
        VOffline
    },
    props: {
        projectId: {
            type: Number,
        },
    },
    data() {
        return {
            isReadOnly: false,
            project: null,
            records: [],
        }
    },
    mixins: [mixin],
    methods: {
        init() {
            const vm = this;
            vm.$store.dispatch("setScreenName", "Records");
            vm.getRecords();
        },
        getRecords() {
            let vm = this;
            const loading = this.$loading({
                lock: true,
                text: 'Please wait loading records...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            healthClinicService.getArchivedRecords(vm.projectId)
            .then((apiResponse) => {
                loading.close();
                vm.records = apiResponse.response.data.records;
                vm.mapRecordWithTable();
            });
        },
        mapRecordWithTable() {
            const vm = this;

            // Define the columns array dynamically based on the isReadOnly flag
            const columns = [
                {
                    data: 'id',
                    'orderable': false,
                    searchable: false,
                    render: function (data, type, row, meta) {
                        return `<input type="checkbox" class="check_input" name="id[]" value="${data}">`;
                    }
                },
                {
                    data: 'created_at',
                    render: function (data) {
                        return vm.convertDate(data);
                    }
                },
                {
                    data: 'archived_by_user',
                    render: function (data) {
                        return data.username ? data.username : `${data.first_name} ${data.last_name}`;
                    }
                },
                {
                    data: 'data.image_url',
                    render: function (data, type) {
                        return type !== 'export'
                            ? '<img src=' + data + ' class="datatable_image_thumbnail" style="cursor: pointer; object-fit: cover;" height="70" width="70"/>'
                            : data;
                    }
                },
                {
                    data: 'data.collar_id'
                },
                {
                    data: 'data.age_category'
                },
                {
                    data: 'data',
                    render: function (data) {
                        const treatment = vm.getNameForTreatmentVaccineDeworming(data, 'given_treatment_ids', 'treatment_name', vm.project.organisation.treatments);
                        return `${treatment}`;
                    }
                },
                {
                    data: 'data',
                    render: function (data) {
                        const deworming = vm.getNameForTreatmentVaccineDeworming(data, 'given_deworming_ids', 'deworming_name', vm.project.organisation.dewormings);
                        return `${deworming}`;
                    }
                },
                {
                    data: 'data',
                    render: function (data) {
                        const vaccination = vm.getNameForTreatmentVaccineDeworming(data, 'given_vaccination_drug_ids', 'vaccination_drug_name', vm.project.organisation.vaccineDrugs);
                        return `${vaccination}`;
                    }
                }
            ]

            $("#hcRecords").DataTable({
                search: {
                    caseInsensitive: false
                },
                data: vm.records,
                destroy: true,
                "order": [[1, "desc"]],
                "scrollX": true,
                responsive: true,
                dom: 'lBfrtip',
                "bInfo": false,
                columns: columns, // Use the dynamically defined columns
                buttons: [
                ],
                'fnRowCallback': function (nRow) {
                    const imageElement = $('.datatable_image_thumbnail', nRow);
                    vm.zoomImagePopup(imageElement);
                    return nRow;
                }
            })
        },
        getNameForTreatmentVaccineDeworming(data, dataKey, valueName, mapedData) {
            mapedData = mapedData ? mapedData : []; 
            const formattedData = ((data[dataKey] && typeof data[dataKey] === 'string') ? JSON.parse(data[dataKey]) : data[dataKey] ? data[dataKey]: []).map((dIds) => {
                return mapedData.length ? mapedData.find((pt) => pt.id == dIds)[valueName] : '';
            }).join(" &bull; ");
            return formattedData || 'N/A';
        },
        inputCheckBox() {
            if (document.getElementById('allCheckbox').checked) {
                document.querySelectorAll('.check_input').forEach(function (element) {
                    element.checked = true;
                });
            } else {
                document.querySelectorAll('.check_input').forEach(function (element) {
                    element.checked = false;
                });
            }
        },
        restoreRecord()
        {
            let vm = this;
            const selectedRecordIds = [];
            document.querySelectorAll('.check_input').forEach(function (element) {
                var inputChecked = element.checked;
                if (inputChecked == true) {
                    selectedRecordIds.push(element.value);
                }
            });
            new Swal({
                icon:'info',
                title: 'Alert!',
                text: 'Are you sure you want to restore archived record(s)?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Restore',
                buttonsStyling: false,
            }).then(function (result) {
                if (result.value) {
                    const loading = vm.$loading({
                        lock: true,
                        text: 'Restoring records...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    healthClinicService.restoreRecords({ ids: selectedRecordIds })
                        .then(response => {
                            response = response.response;
                            loading.close();
                            if (response.error.error_code == 0) {
                                vm.getRecords();
                                vm.showAlert('Success', response.error.msg, true);
                            } else {
                                vm.showAlert('Error', response.error.error_msg, false);
                            }
                        })
                        .catch(error => {
                            loading.close();
                            console.log(error);
                        })

                }
            });
        }
    },
    mounted() {
        let vm = this;
        vm.project = vm.$store.getters.getCurrentSelectedProject;
        vm.isReadOnly = false
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if (r.role_name == 'VIEWER') {
                vm.isReadOnly = true
            }
        });
        vm.init();
    }
}

</script>
